import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface NavState {
  open: boolean;
  mini: boolean;
}

const initialState: NavState = {
  open: false,
  mini: false,
};

export const navSlice = createSlice({
  name: 'nav',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    toggle: (state) => {
      state.open = !state.open;
    },
    open: (state) => {
      state.open = true;
    },
    close: (state) => {
      state.open = false;
    },
    toggleMini: (state) => {
      state.mini = !state.mini;
    },
  },
});

export const { toggle, open, close, toggleMini } = navSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectOpen = (state: RootState) => state.nav.open;
export const selectMini = (state: RootState) => state.nav.mini;

export default navSlice.reducer;
